const RANKING = [
  { rank: 1, title: '庆余年 第二季', type: '电视剧', hot: '9.8', trend: 'up' },
  { rank: 2, title: '热辣滚烫', type: '电影', hot: '9.6', trend: 'up' },
  { rank: 3, title: '歌手2024', type: '综艺', hot: '9.5', trend: 'new' },
  { rank: 4, title: '海贼王', type: '动漫', hot: '9.3', trend: 'up' },
  { rank: 5, title: '唐朝诡事录之西行', type: '电视剧', hot: '9.1', trend: 'up' },
  { rank: 6, title: '飞驰人生2', type: '电影', hot: '8.9', trend: 'down' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-3">
          热播风云榜
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          实时热度排行，看看大家都在看什么
        </p>
        <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
          {RANKING.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 px-5 py-4 ${
                i < RANKING.length - 1 ? 'border-b border-background-200/40' : ''
              } hover:bg-background-100/50 transition-colors cursor-pointer`}
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-bold text-sm flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate">
                  {item.title}
                </h3>
              </div>
              <span className="px-2.5 py-1 rounded-full bg-background-100 text-xs text-foreground-500 flex-shrink-0 whitespace-nowrap">
                {item.type}
              </span>
              <div className="flex items-center gap-1 flex-shrink-0">
                <span className="text-sm font-bold text-primary-500">{item.hot}</span>
                {item.trend === 'up' && (
                  <i className="ri-arrow-up-line text-xs text-primary-500"></i>
                )}
                {item.trend === 'down' && (
                  <i className="ri-arrow-down-line text-xs text-accent-600"></i>
                )}
                {item.trend === 'new' && (
                  <span className="text-[10px] px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 font-medium">NEW</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}